import { ApiService } from "@/api";

export const updateAdminQualityNotes = (sampleId: string, note: string) => {
  return ApiService.baseAction(
    `admin-quality/note/${sampleId}`,
    {
      data: {
        note,
      },
    },
    "post"
  );
};
